// src/pages/offlineSales/components/CustomerStatementA4.jsx
// Cloned from OfflineOrderA4Invoice.jsx's structure — same A4DocumentLayout shape, with the
// "items" table listing the statement's ledger rows instead of order line items.
import React from 'react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import A4DocumentLayout from '../../../components/common/A4DocumentLayout/A4DocumentLayout';

const TYPE_LABELS = {
  invoice: 'Invoice',
  payment: 'Payment Received',
  credit_note: 'Credit Note',
  return: 'Refund (Cash)',
  opening_balance: 'Opening Balance',
  customer_payment: 'Customer Payment',
  customer_payment_reversal: 'Payment Reversed',
};

const CustomerStatementA4 = ({ statement }) => {
  const { t, formatCurrency } = useLocalization();

  if (!statement) return null;

  return (
    <A4DocumentLayout
      title="CUSTOMER STATEMENT"
      subtitle={statement.customer?.name}
      documentNumber={`${statement.dateFrom || 'Account start'} — ${statement.dateTo || 'Today'}`}
      metaRows={[
        { label: t('offlineSales.openingBalance', 'Opening Balance'), value: formatCurrency(statement.openingBalance) },
        { label: t('offlineSales.closingBalance', 'Closing Balance'), value: formatCurrency(statement.closingBalance) },
      ]}
      infoCards={[
        {
          title: t('offlineSales.customerInformation'),
          primary: statement.customer?.name || '—',
          lines: [
            statement.customer?.phone && `${t('offlineSales.customerPhone')}: ${statement.customer.phone}`,
            statement.customer?.tinNumber && `${t('offlineSales.tinNumber')}: ${statement.customer.tinNumber}`,
            statement.customer?.vatNumber && `${t('offlineSales.vatNumber')}: ${statement.customer.vatNumber}`,
          ].filter(Boolean),
        },
      ]}
      items={{
        columns: [
          { header: t('offlineSales.date') },
          { header: t('offlineSales.statusCol') },
          { header: t('offlineSales.reference') },
          { header: t('offlineSales.debit', 'Debit'), align: 'right' },
          { header: t('offlineSales.credit', 'Credit'), align: 'right' },
          { header: t('offlineSales.balanceCol'), align: 'right' },
        ],
        rows: (statement.transactions || []).map((tx) => [
          new Date(tx.date).toLocaleDateString(),
          TYPE_LABELS[tx.type] || tx.type,
          tx.reference || '—',
          tx.debit > 0 ? formatCurrency(tx.debit) : '—',
          tx.credit > 0 ? formatCurrency(tx.credit) : '—',
          formatCurrency(tx.runningBalance),
        ]),
      }}
      summary={{
        totals: [
          { label: t('offlineSales.openingBalance', 'Opening Balance'), value: formatCurrency(statement.openingBalance) },
          { label: t('offlineSales.closingBalance', 'Closing Balance'), value: formatCurrency(statement.closingBalance), variant: 'grand' },
        ],
      }}
      footerText={t('offlineSales.thankYouMessage', 'Thank you for your business!')}
      footerNote="This is a computer-generated statement."
    />
  );
};

export default CustomerStatementA4;
